"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-report/insight.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-report%2Finsight.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastPullDetailsLastPullStatusToJSON = exports.lastPullDetailsLastPullStatusFromJSON = exports.scoreTypeToJSON = exports.scoreTypeFromJSON = exports.insightResponseFileTypeToJSON = exports.insightResponseFileTypeFromJSON = exports.insightBatchFileStatusToJSON = exports.insightBatchFileStatusFromJSON = exports.insightUserRequestStatusToJSON = exports.insightUserRequestStatusFromJSON = exports.insightVendorToJSON = exports.insightVendorFromJSON = exports.InsightUserRequestInfo = exports.LastPullDetails = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails = exports.TransUnionAdverseCodeDetails = exports.TransUnionAdverseCodesAdverseActionCode = exports.TransUnionAdverseCodes = exports.DataPoint = exports.TransUnionCreditData = exports.FinScore = exports.TransUnionUserResponseData = exports.InsightUserResponseData = exports.LastPullDetailsLastPullStatus = exports.ScoreType = exports.InsightResponseFileType = exports.InsightBatchFileStatus = exports.InsightUserRequestStatus = exports.InsightVendor = void 0;
const date_1 = require("../common/date");
const protobufPackage = 'com.step.creditreport.insight.proto';
/**
 * The vendors that we're pulling credit score information from.
 */
var InsightVendor;
(function (InsightVendor) {
    InsightVendor["INVALID_VENDOR"] = "INVALID_VENDOR";
    InsightVendor["TRANSUNION"] = "TRANSUNION";
    InsightVendor["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InsightVendor || (exports.InsightVendor = InsightVendor = {}));
/**
 * Captures the status of a credit pull request for a user.
 */
var InsightUserRequestStatus;
(function (InsightUserRequestStatus) {
    InsightUserRequestStatus["INVALID_USER_STATUS"] = "INVALID_USER_STATUS";
    /**
     * ERROR_PRE_REQUEST - Failed to prepare the request for the vendor.
     */
    InsightUserRequestStatus["ERROR_PRE_REQUEST"] = "ERROR_PRE_REQUEST";
    /**
     * PENDING_RESPONSE - Waiting for a response from the vendor.
     */
    InsightUserRequestStatus["PENDING_RESPONSE"] = "PENDING_RESPONSE";
    /**
     * ACCEPTED - Vendor responded with an "accept" meaning user was found in system and
     * credit information has been provided for this request.
     */
    InsightUserRequestStatus["ACCEPTED"] = "ACCEPTED";
    /**
     * ACCEPTED_DECEASED - User found in system, but is marked as deceased (a credit score is not
     * present for this response)
     */
    InsightUserRequestStatus["ACCEPTED_DECEASED"] = "ACCEPTED_DECEASED";
    /**
     * ACCEPTED_MISSING_DATA - User found in system, but they "do not have any trades, collections, or
     * public records" (a credit score is not present for this response)
     */
    InsightUserRequestStatus["ACCEPTED_MISSING_DATA"] = "ACCEPTED_MISSING_DATA";
    /**
     * NO_HIT - Vendor responded with a "no hit" meaning they couldn't find the requested
     * user in their system.
     */
    InsightUserRequestStatus["NO_HIT"] = "NO_HIT";
    /**
     * ERROR_REJECTED - Vendor responded with a "reject" meaning there was something wrong with
     * the way the request was prepared.
     */
    InsightUserRequestStatus["ERROR_REJECTED"] = "ERROR_REJECTED";
    /**
     * TIMED_OUT - Vendor did not provide a response for this file.
     */
    InsightUserRequestStatus["TIMED_OUT"] = "TIMED_OUT";
    /**
     * CRITERIA_REJECTED - Vendor found user in system but failed a vendor specific criteria topic.
     * No credit score is present in this case.
     */
    InsightUserRequestStatus["CRITERIA_REJECTED"] = "CRITERIA_REJECTED";
    InsightUserRequestStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InsightUserRequestStatus || (exports.InsightUserRequestStatus = InsightUserRequestStatus = {}));
/**
 * The status of a credit pull input file.
 */
var InsightBatchFileStatus;
(function (InsightBatchFileStatus) {
    InsightBatchFileStatus["INVALID_BATCH_FILE_STATUS"] = "INVALID_BATCH_FILE_STATUS";
    /**
     * PENDING - File has not yet been uploaded to vendor.
     */
    InsightBatchFileStatus["PENDING"] = "PENDING";
    /**
     * UPLOADED - File has been uploaded to vendor.
     */
    InsightBatchFileStatus["UPLOADED"] = "UPLOADED";
    InsightBatchFileStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InsightBatchFileStatus || (exports.InsightBatchFileStatus = InsightBatchFileStatus = {}));
/**
 * The insight response file type.
 */
var InsightResponseFileType;
(function (InsightResponseFileType) {
    InsightResponseFileType["INVALID_FILE_TYPE"] = "INVALID_FILE_TYPE";
    /**
     * ACCEPT - An "accept" file (contains credit information for requested users)
     */
    InsightResponseFileType["ACCEPT"] = "ACCEPT";
    /**
     * REJECT - A "reject" file (contains error information for requested users)
     */
    InsightResponseFileType["REJECT"] = "REJECT";
    InsightResponseFileType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InsightResponseFileType || (exports.InsightResponseFileType = InsightResponseFileType = {}));
/**
 * The type of credit score.
 */
var ScoreType;
(function (ScoreType) {
    ScoreType["INVALID_SCORE_TYPE"] = "INVALID_SCORE_TYPE";
    /**
     * VS3 - VantageScore 3.0
     */
    ScoreType["VS3"] = "VS3";
    /**
     * VS4 - VantageScore 4.0
     */
    ScoreType["VS4"] = "VS4";
    ScoreType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ScoreType || (exports.ScoreType = ScoreType = {}));
var LastPullDetailsLastPullStatus;
(function (LastPullDetailsLastPullStatus) {
    LastPullDetailsLastPullStatus["INVALID_LAST_PULL_STATUS"] = "INVALID_LAST_PULL_STATUS";
    /**
     * OK - The last pull was OK.
     */
    LastPullDetailsLastPullStatus["OK"] = "OK";
    /**
     * NO_HIT - User could not be found in the credit bureau's system.
     */
    LastPullDetailsLastPullStatus["NO_HIT"] = "NO_HIT";
    /**
     * NO_CREDIT - User was found in credit bureau's system, but there was no credit score for them.
     */
    LastPullDetailsLastPullStatus["NO_CREDIT"] = "NO_CREDIT";
    /**
     * USER_ERROR - There was some other issue when processing bureau's response record for the
     * user (likely being reviewed by CX)
     */
    LastPullDetailsLastPullStatus["USER_ERROR"] = "USER_ERROR";
    LastPullDetailsLastPullStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(LastPullDetailsLastPullStatus || (exports.LastPullDetailsLastPullStatus = LastPullDetailsLastPullStatus = {}));
function createBaseInsightUserResponseData() {
    return { transunion: undefined };
}
exports.InsightUserResponseData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.transunion)) {
            message.transunion = exports.TransUnionUserResponseData.fromJSON(object.transunion);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transunion !== undefined) {
            obj.transunion = exports.TransUnionUserResponseData.toJSON(message.transunion);
        }
        return obj;
    },
    create(base) {
        return exports.InsightUserResponseData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInsightUserResponseData();
        message.transunion = (object.transunion !== undefined && object.transunion !== null)
            ? exports.TransUnionUserResponseData.fromPartial(object.transunion)
            : undefined;
        return message;
    },
};
function createBaseTransUnionUserResponseData() {
    return {
        inputFullName: '',
        inputFiller: '',
        creditAsOfDate: date_1.LocalDate.fromPartial({}),
        finScore: '',
        adverseActionCodes: undefined,
        scores: [],
        permId: '',
    };
}
exports.TransUnionUserResponseData = {
    fromJSON(object) {
        const message = {
            inputFullName: isSet(object.inputFullName) ? globalThis.String(object.inputFullName) : '',
            inputFiller: isSet(object.inputFiller) ? globalThis.String(object.inputFiller) : '',
            creditAsOfDate: isSet(object.creditAsOfDate)
                ? date_1.LocalDate.fromJSON(object.creditAsOfDate)
                : date_1.LocalDate.fromPartial({}),
            finScore: isSet(object.finScore) ? globalThis.String(object.finScore) : '',
        };
        if (isSet(object.adverseActionCodes)) {
            message.adverseActionCodes = exports.TransUnionAdverseCodes.fromJSON(object.adverseActionCodes);
        }
        if (globalThis.Array.isArray(object?.scores)) {
            message.scores = object.scores.map((e) => exports.FinScore.fromJSON(e));
        }
        if (isSet(object.permId)) {
            message.permId = globalThis.String(object.permId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.inputFullName !== '') {
            obj.inputFullName = message.inputFullName;
        }
        if (message.inputFiller !== '') {
            obj.inputFiller = message.inputFiller;
        }
        if (message.creditAsOfDate !== undefined) {
            obj.creditAsOfDate = date_1.LocalDate.toJSON(message.creditAsOfDate);
        }
        if (message.finScore !== '') {
            obj.finScore = message.finScore;
        }
        if (message.adverseActionCodes !== undefined) {
            obj.adverseActionCodes = exports.TransUnionAdverseCodes.toJSON(message.adverseActionCodes);
        }
        if (message.scores?.length) {
            obj.scores = message.scores.map((e) => exports.FinScore.toJSON(e));
        }
        if (message.permId !== undefined && message.permId !== '') {
            obj.permId = message.permId;
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionUserResponseData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionUserResponseData();
        message.inputFullName = object.inputFullName ?? '';
        message.inputFiller = object.inputFiller ?? '';
        message.creditAsOfDate = (object.creditAsOfDate !== undefined && object.creditAsOfDate !== null)
            ? date_1.LocalDate.fromPartial(object.creditAsOfDate)
            : date_1.LocalDate.fromPartial({});
        message.finScore = object.finScore ?? '';
        message.adverseActionCodes =
            (object.adverseActionCodes !== undefined && object.adverseActionCodes !== null)
                ? exports.TransUnionAdverseCodes.fromPartial(object.adverseActionCodes)
                : undefined;
        message.scores = object.scores?.map((e) => exports.FinScore.fromPartial(e)) || [];
        message.permId = object.permId ?? '';
        return message;
    },
};
function createBaseFinScore() {
    return { score: '', type: ScoreType.INVALID_SCORE_TYPE };
}
exports.FinScore = {
    fromJSON(object) {
        const message = {
            score: isSet(object.score) ? globalThis.String(object.score) : '',
            type: isSet(object.type) ? scoreTypeFromJSON(object.type) : ScoreType.INVALID_SCORE_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.score !== '') {
            obj.score = message.score;
        }
        if (message.type !== ScoreType.INVALID_SCORE_TYPE) {
            obj.type = scoreTypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.FinScore.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFinScore();
        message.score = object.score ?? '';
        message.type = object.type ?? ScoreType.INVALID_SCORE_TYPE;
        return message;
    },
};
function createBaseTransUnionCreditData() {
    return { creditHistory: [], lastPullDetails: undefined };
}
exports.TransUnionCreditData = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.creditHistory)) {
            message.creditHistory = object.creditHistory.map((e) => exports.DataPoint.fromJSON(e));
        }
        if (isSet(object.lastPullDetails)) {
            message.lastPullDetails = exports.LastPullDetails.fromJSON(object.lastPullDetails);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditHistory?.length) {
            obj.creditHistory = message.creditHistory.map((e) => exports.DataPoint.toJSON(e));
        }
        if (message.lastPullDetails !== undefined) {
            obj.lastPullDetails = exports.LastPullDetails.toJSON(message.lastPullDetails);
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionCreditData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionCreditData();
        message.creditHistory = object.creditHistory?.map((e) => exports.DataPoint.fromPartial(e)) || [];
        message.lastPullDetails =
            (object.lastPullDetails !== undefined && object.lastPullDetails !== null)
                ? exports.LastPullDetails.fromPartial(object.lastPullDetails)
                : undefined;
        return message;
    },
};
function createBaseDataPoint() {
    return { creditAsOfDate: date_1.LocalDate.fromPartial({}), score: 0 };
}
exports.DataPoint = {
    fromJSON(object) {
        const message = {
            creditAsOfDate: isSet(object.creditAsOfDate)
                ? date_1.LocalDate.fromJSON(object.creditAsOfDate)
                : date_1.LocalDate.fromPartial({}),
            score: isSet(object.score) ? globalThis.Number(object.score) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditAsOfDate !== undefined) {
            obj.creditAsOfDate = date_1.LocalDate.toJSON(message.creditAsOfDate);
        }
        if (message.score !== 0) {
            obj.score = Math.round(message.score);
        }
        return obj;
    },
    create(base) {
        return exports.DataPoint.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDataPoint();
        message.creditAsOfDate = (object.creditAsOfDate !== undefined && object.creditAsOfDate !== null)
            ? date_1.LocalDate.fromPartial(object.creditAsOfDate)
            : date_1.LocalDate.fromPartial({});
        message.score = object.score ?? 0;
        return message;
    },
};
function createBaseTransUnionAdverseCodes() {
    return {
        adverseActionCode1: undefined,
        adverseActionCode2: undefined,
        adverseActionCode3: undefined,
        adverseActionCode4: undefined,
        adverseActionCode5: undefined,
    };
}
exports.TransUnionAdverseCodes = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.adverseActionCode1)) {
            message.adverseActionCode1 = exports.TransUnionAdverseCodesAdverseActionCode.fromJSON(object.adverseActionCode1);
        }
        if (isSet(object.adverseActionCode2)) {
            message.adverseActionCode2 = exports.TransUnionAdverseCodesAdverseActionCode.fromJSON(object.adverseActionCode2);
        }
        if (isSet(object.adverseActionCode3)) {
            message.adverseActionCode3 = exports.TransUnionAdverseCodesAdverseActionCode.fromJSON(object.adverseActionCode3);
        }
        if (isSet(object.adverseActionCode4)) {
            message.adverseActionCode4 = exports.TransUnionAdverseCodesAdverseActionCode.fromJSON(object.adverseActionCode4);
        }
        if (isSet(object.adverseActionCode5)) {
            message.adverseActionCode5 = exports.TransUnionAdverseCodesAdverseActionCode.fromJSON(object.adverseActionCode5);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.adverseActionCode1 !== undefined) {
            obj.adverseActionCode1 = exports.TransUnionAdverseCodesAdverseActionCode.toJSON(message.adverseActionCode1);
        }
        if (message.adverseActionCode2 !== undefined) {
            obj.adverseActionCode2 = exports.TransUnionAdverseCodesAdverseActionCode.toJSON(message.adverseActionCode2);
        }
        if (message.adverseActionCode3 !== undefined) {
            obj.adverseActionCode3 = exports.TransUnionAdverseCodesAdverseActionCode.toJSON(message.adverseActionCode3);
        }
        if (message.adverseActionCode4 !== undefined) {
            obj.adverseActionCode4 = exports.TransUnionAdverseCodesAdverseActionCode.toJSON(message.adverseActionCode4);
        }
        if (message.adverseActionCode5 !== undefined) {
            obj.adverseActionCode5 = exports.TransUnionAdverseCodesAdverseActionCode.toJSON(message.adverseActionCode5);
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionAdverseCodes.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionAdverseCodes();
        message.adverseActionCode1 =
            (object.adverseActionCode1 !== undefined && object.adverseActionCode1 !== null)
                ? exports.TransUnionAdverseCodesAdverseActionCode.fromPartial(object.adverseActionCode1)
                : undefined;
        message.adverseActionCode2 =
            (object.adverseActionCode2 !== undefined && object.adverseActionCode2 !== null)
                ? exports.TransUnionAdverseCodesAdverseActionCode.fromPartial(object.adverseActionCode2)
                : undefined;
        message.adverseActionCode3 =
            (object.adverseActionCode3 !== undefined && object.adverseActionCode3 !== null)
                ? exports.TransUnionAdverseCodesAdverseActionCode.fromPartial(object.adverseActionCode3)
                : undefined;
        message.adverseActionCode4 =
            (object.adverseActionCode4 !== undefined && object.adverseActionCode4 !== null)
                ? exports.TransUnionAdverseCodesAdverseActionCode.fromPartial(object.adverseActionCode4)
                : undefined;
        message.adverseActionCode5 =
            (object.adverseActionCode5 !== undefined && object.adverseActionCode5 !== null)
                ? exports.TransUnionAdverseCodesAdverseActionCode.fromPartial(object.adverseActionCode5)
                : undefined;
        return message;
    },
};
function createBaseTransUnionAdverseCodesAdverseActionCode() {
    return { code: '' };
}
exports.TransUnionAdverseCodesAdverseActionCode = {
    fromJSON(object) {
        const message = {
            code: isSet(object.code) ? globalThis.String(object.code) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== '') {
            obj.code = message.code;
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionAdverseCodesAdverseActionCode.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionAdverseCodesAdverseActionCode();
        message.code = object.code ?? '';
        return message;
    },
};
function createBaseTransUnionAdverseCodeDetails() {
    return {
        adverseActionCode1: undefined,
        adverseActionCode2: undefined,
        adverseActionCode3: undefined,
        adverseActionCode4: undefined,
        adverseActionCode5: undefined,
    };
}
exports.TransUnionAdverseCodeDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.adverseActionCode1)) {
            message.adverseActionCode1 = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromJSON(object.adverseActionCode1);
        }
        if (isSet(object.adverseActionCode2)) {
            message.adverseActionCode2 = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromJSON(object.adverseActionCode2);
        }
        if (isSet(object.adverseActionCode3)) {
            message.adverseActionCode3 = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromJSON(object.adverseActionCode3);
        }
        if (isSet(object.adverseActionCode4)) {
            message.adverseActionCode4 = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromJSON(object.adverseActionCode4);
        }
        if (isSet(object.adverseActionCode5)) {
            message.adverseActionCode5 = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromJSON(object.adverseActionCode5);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.adverseActionCode1 !== undefined) {
            obj.adverseActionCode1 = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.toJSON(message.adverseActionCode1);
        }
        if (message.adverseActionCode2 !== undefined) {
            obj.adverseActionCode2 = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.toJSON(message.adverseActionCode2);
        }
        if (message.adverseActionCode3 !== undefined) {
            obj.adverseActionCode3 = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.toJSON(message.adverseActionCode3);
        }
        if (message.adverseActionCode4 !== undefined) {
            obj.adverseActionCode4 = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.toJSON(message.adverseActionCode4);
        }
        if (message.adverseActionCode5 !== undefined) {
            obj.adverseActionCode5 = exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.toJSON(message.adverseActionCode5);
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionAdverseCodeDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionAdverseCodeDetails();
        message.adverseActionCode1 =
            (object.adverseActionCode1 !== undefined && object.adverseActionCode1 !== null)
                ? exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromPartial(object.adverseActionCode1)
                : undefined;
        message.adverseActionCode2 =
            (object.adverseActionCode2 !== undefined && object.adverseActionCode2 !== null)
                ? exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromPartial(object.adverseActionCode2)
                : undefined;
        message.adverseActionCode3 =
            (object.adverseActionCode3 !== undefined && object.adverseActionCode3 !== null)
                ? exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromPartial(object.adverseActionCode3)
                : undefined;
        message.adverseActionCode4 =
            (object.adverseActionCode4 !== undefined && object.adverseActionCode4 !== null)
                ? exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromPartial(object.adverseActionCode4)
                : undefined;
        message.adverseActionCode5 =
            (object.adverseActionCode5 !== undefined && object.adverseActionCode5 !== null)
                ? exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromPartial(object.adverseActionCode5)
                : undefined;
        return message;
    },
};
function createBaseTransUnionAdverseCodeDetailsAdverseActionCodeDetails() {
    return { code: '', description: '' };
}
exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails = {
    fromJSON(object) {
        const message = {
            code: isSet(object.code) ? globalThis.String(object.code) : '',
            description: isSet(object.description) ? globalThis.String(object.description) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== '') {
            obj.code = message.code;
        }
        if (message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionAdverseCodeDetailsAdverseActionCodeDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionAdverseCodeDetailsAdverseActionCodeDetails();
        message.code = object.code ?? '';
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseLastPullDetails() {
    return {
        timestampMs: '0',
        status: LastPullDetailsLastPullStatus.INVALID_LAST_PULL_STATUS,
        adverseActionCodes: undefined,
        detailedReportId: '',
    };
}
exports.LastPullDetails = {
    fromJSON(object) {
        const message = {
            timestampMs: isSet(object.timestampMs) ? globalThis.String(object.timestampMs) : '0',
            status: isSet(object.status)
                ? lastPullDetailsLastPullStatusFromJSON(object.status)
                : LastPullDetailsLastPullStatus.INVALID_LAST_PULL_STATUS,
        };
        if (isSet(object.adverseActionCodes)) {
            message.adverseActionCodes = exports.TransUnionAdverseCodeDetails.fromJSON(object.adverseActionCodes);
        }
        if (isSet(object.detailedReportId)) {
            message.detailedReportId = globalThis.String(object.detailedReportId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.timestampMs !== '0') {
            obj.timestampMs = message.timestampMs;
        }
        if (message.status !== LastPullDetailsLastPullStatus.INVALID_LAST_PULL_STATUS) {
            obj.status = lastPullDetailsLastPullStatusToJSON(message.status);
        }
        if (message.adverseActionCodes !== undefined) {
            obj.adverseActionCodes = exports.TransUnionAdverseCodeDetails.toJSON(message.adverseActionCodes);
        }
        if (message.detailedReportId !== undefined && message.detailedReportId !== '') {
            obj.detailedReportId = message.detailedReportId;
        }
        return obj;
    },
    create(base) {
        return exports.LastPullDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLastPullDetails();
        message.timestampMs = object.timestampMs ?? '0';
        message.status = object.status ?? LastPullDetailsLastPullStatus.INVALID_LAST_PULL_STATUS;
        message.adverseActionCodes =
            (object.adverseActionCodes !== undefined && object.adverseActionCodes !== null)
                ? exports.TransUnionAdverseCodeDetails.fromPartial(object.adverseActionCodes)
                : undefined;
        message.detailedReportId = object.detailedReportId ?? '';
        return message;
    },
};
function createBaseInsightUserRequestInfo() {
    return {
        refId: '',
        vendor: InsightVendor.INVALID_VENDOR,
        responseDataEncrypted: new Uint8Array(0),
        skipEtl: false,
    };
}
exports.InsightUserRequestInfo = {
    fromJSON(object) {
        const message = {
            refId: isSet(object.refId) ? globalThis.String(object.refId) : '',
            vendor: isSet(object.vendor)
                ? insightVendorFromJSON(object.vendor)
                : InsightVendor.INVALID_VENDOR,
        };
        if (isSet(object.responseDataEncrypted)) {
            message.responseDataEncrypted = bytesFromBase64(object.responseDataEncrypted);
        }
        if (isSet(object.skipEtl)) {
            message.skipEtl = globalThis.Boolean(object.skipEtl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.refId !== '') {
            obj.refId = message.refId;
        }
        if (message.vendor !== InsightVendor.INVALID_VENDOR) {
            obj.vendor = insightVendorToJSON(message.vendor);
        }
        if (message.responseDataEncrypted !== undefined && message.responseDataEncrypted.length !== 0) {
            obj.responseDataEncrypted = base64FromBytes(message.responseDataEncrypted);
        }
        if (message.skipEtl !== undefined && message.skipEtl !== false) {
            obj.skipEtl = message.skipEtl;
        }
        return obj;
    },
    create(base) {
        return exports.InsightUserRequestInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInsightUserRequestInfo();
        message.refId = object.refId ?? '';
        message.vendor = object.vendor ?? InsightVendor.INVALID_VENDOR;
        message.responseDataEncrypted = object.responseDataEncrypted ?? new Uint8Array(0);
        message.skipEtl = object.skipEtl ?? false;
        return message;
    },
};
function insightVendorFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_VENDOR':
            return InsightVendor.INVALID_VENDOR;
        case 1:
        case 'TRANSUNION':
            return InsightVendor.TRANSUNION;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InsightVendor.UNRECOGNIZED;
    }
}
exports.insightVendorFromJSON = insightVendorFromJSON;
function insightVendorToJSON(object) {
    switch (object) {
        case InsightVendor.INVALID_VENDOR:
            return 'INVALID_VENDOR';
        case InsightVendor.TRANSUNION:
            return 'TRANSUNION';
        case InsightVendor.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.insightVendorToJSON = insightVendorToJSON;
function insightUserRequestStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_USER_STATUS':
            return InsightUserRequestStatus.INVALID_USER_STATUS;
        case 1:
        case 'ERROR_PRE_REQUEST':
            return InsightUserRequestStatus.ERROR_PRE_REQUEST;
        case 2:
        case 'PENDING_RESPONSE':
            return InsightUserRequestStatus.PENDING_RESPONSE;
        case 3:
        case 'ACCEPTED':
            return InsightUserRequestStatus.ACCEPTED;
        case 6:
        case 'ACCEPTED_DECEASED':
            return InsightUserRequestStatus.ACCEPTED_DECEASED;
        case 7:
        case 'ACCEPTED_MISSING_DATA':
            return InsightUserRequestStatus.ACCEPTED_MISSING_DATA;
        case 4:
        case 'NO_HIT':
            return InsightUserRequestStatus.NO_HIT;
        case 5:
        case 'ERROR_REJECTED':
            return InsightUserRequestStatus.ERROR_REJECTED;
        case 8:
        case 'TIMED_OUT':
            return InsightUserRequestStatus.TIMED_OUT;
        case 9:
        case 'CRITERIA_REJECTED':
            return InsightUserRequestStatus.CRITERIA_REJECTED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InsightUserRequestStatus.UNRECOGNIZED;
    }
}
exports.insightUserRequestStatusFromJSON = insightUserRequestStatusFromJSON;
function insightUserRequestStatusToJSON(object) {
    switch (object) {
        case InsightUserRequestStatus.INVALID_USER_STATUS:
            return 'INVALID_USER_STATUS';
        case InsightUserRequestStatus.ERROR_PRE_REQUEST:
            return 'ERROR_PRE_REQUEST';
        case InsightUserRequestStatus.PENDING_RESPONSE:
            return 'PENDING_RESPONSE';
        case InsightUserRequestStatus.ACCEPTED:
            return 'ACCEPTED';
        case InsightUserRequestStatus.ACCEPTED_DECEASED:
            return 'ACCEPTED_DECEASED';
        case InsightUserRequestStatus.ACCEPTED_MISSING_DATA:
            return 'ACCEPTED_MISSING_DATA';
        case InsightUserRequestStatus.NO_HIT:
            return 'NO_HIT';
        case InsightUserRequestStatus.ERROR_REJECTED:
            return 'ERROR_REJECTED';
        case InsightUserRequestStatus.TIMED_OUT:
            return 'TIMED_OUT';
        case InsightUserRequestStatus.CRITERIA_REJECTED:
            return 'CRITERIA_REJECTED';
        case InsightUserRequestStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.insightUserRequestStatusToJSON = insightUserRequestStatusToJSON;
function insightBatchFileStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_BATCH_FILE_STATUS':
            return InsightBatchFileStatus.INVALID_BATCH_FILE_STATUS;
        case 1:
        case 'PENDING':
            return InsightBatchFileStatus.PENDING;
        case 2:
        case 'UPLOADED':
            return InsightBatchFileStatus.UPLOADED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InsightBatchFileStatus.UNRECOGNIZED;
    }
}
exports.insightBatchFileStatusFromJSON = insightBatchFileStatusFromJSON;
function insightBatchFileStatusToJSON(object) {
    switch (object) {
        case InsightBatchFileStatus.INVALID_BATCH_FILE_STATUS:
            return 'INVALID_BATCH_FILE_STATUS';
        case InsightBatchFileStatus.PENDING:
            return 'PENDING';
        case InsightBatchFileStatus.UPLOADED:
            return 'UPLOADED';
        case InsightBatchFileStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.insightBatchFileStatusToJSON = insightBatchFileStatusToJSON;
function insightResponseFileTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_FILE_TYPE':
            return InsightResponseFileType.INVALID_FILE_TYPE;
        case 1:
        case 'ACCEPT':
            return InsightResponseFileType.ACCEPT;
        case 2:
        case 'REJECT':
            return InsightResponseFileType.REJECT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InsightResponseFileType.UNRECOGNIZED;
    }
}
exports.insightResponseFileTypeFromJSON = insightResponseFileTypeFromJSON;
function insightResponseFileTypeToJSON(object) {
    switch (object) {
        case InsightResponseFileType.INVALID_FILE_TYPE:
            return 'INVALID_FILE_TYPE';
        case InsightResponseFileType.ACCEPT:
            return 'ACCEPT';
        case InsightResponseFileType.REJECT:
            return 'REJECT';
        case InsightResponseFileType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.insightResponseFileTypeToJSON = insightResponseFileTypeToJSON;
function scoreTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SCORE_TYPE':
            return ScoreType.INVALID_SCORE_TYPE;
        case 1:
        case 'VS3':
            return ScoreType.VS3;
        case 2:
        case 'VS4':
            return ScoreType.VS4;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ScoreType.UNRECOGNIZED;
    }
}
exports.scoreTypeFromJSON = scoreTypeFromJSON;
function scoreTypeToJSON(object) {
    switch (object) {
        case ScoreType.INVALID_SCORE_TYPE:
            return 'INVALID_SCORE_TYPE';
        case ScoreType.VS3:
            return 'VS3';
        case ScoreType.VS4:
            return 'VS4';
        case ScoreType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.scoreTypeToJSON = scoreTypeToJSON;
function lastPullDetailsLastPullStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_LAST_PULL_STATUS':
            return LastPullDetailsLastPullStatus.INVALID_LAST_PULL_STATUS;
        case 1:
        case 'OK':
            return LastPullDetailsLastPullStatus.OK;
        case 2:
        case 'NO_HIT':
            return LastPullDetailsLastPullStatus.NO_HIT;
        case 3:
        case 'NO_CREDIT':
            return LastPullDetailsLastPullStatus.NO_CREDIT;
        case 4:
        case 'USER_ERROR':
            return LastPullDetailsLastPullStatus.USER_ERROR;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return LastPullDetailsLastPullStatus.UNRECOGNIZED;
    }
}
exports.lastPullDetailsLastPullStatusFromJSON = lastPullDetailsLastPullStatusFromJSON;
function lastPullDetailsLastPullStatusToJSON(object) {
    switch (object) {
        case LastPullDetailsLastPullStatus.INVALID_LAST_PULL_STATUS:
            return 'INVALID_LAST_PULL_STATUS';
        case LastPullDetailsLastPullStatus.OK:
            return 'OK';
        case LastPullDetailsLastPullStatus.NO_HIT:
            return 'NO_HIT';
        case LastPullDetailsLastPullStatus.NO_CREDIT:
            return 'NO_CREDIT';
        case LastPullDetailsLastPullStatus.USER_ERROR:
            return 'USER_ERROR';
        case LastPullDetailsLastPullStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.lastPullDetailsLastPullStatusToJSON = lastPullDetailsLastPullStatusToJSON;
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, 'base64'));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString('base64');
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(''));
    }
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=insight.js.map